import type { MediaKind } from '@/entries'
import type { EnrichedMediaResult } from '@/enrichment'

/** Maximum characters for displaying long text */
export const MAX_TITLE_LENGTH = 60
export const MAX_SUBTITLE_LENGTH = 50
export const MAX_GENRE_LENGTH = 20

/**
 * Truncate text to a maximum length with ellipsis
 */
export function truncateText(
  text: string | undefined,
  maxLength: number,
): string {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return `${text.slice(0, maxLength).trim()}…`
}

/**
 * Generate subtitle for media preview based on type and enriched data
 */
export function getSubtitle(
  type: MediaKind,
  enriched: NonNullable<EnrichedMediaResult['enriched']>,
): string {
  switch (type) {
    case 'movie':
      return [enriched.director, enriched.year].filter(Boolean).join(' • ')
    case 'book':
      return [enriched.author, enriched.year].filter(Boolean).join(' • ')
    case 'artist':
      return enriched.labels?.slice(0, 2).join(', ') || ''
    case 'label':
      // Show notable artists on the label
      return (
        enriched.artistNames?.slice(0, 3).join(', ') || enriched.website || ''
      )
    case 'release':
      return [enriched.artistName, enriched.labelName]
        .filter(Boolean)
        .join(' • ')
    default:
      return ''
  }
}
